/** Web 高频业务实体显示名；轻量入口不得依赖运行时 schema。 */
export const ENTITY_LABEL = {
  lead: '线索',
  customer: '客户',
  owner: '业主',
  supplier: '厂商',
} as const

export type EntityLabel = (typeof ENTITY_LABEL)[keyof typeof ENTITY_LABEL]
